import { useEffect, useState } from 'react'
import { Container, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import orderBy from 'lodash/orderBy'
import useTranslate from '../i18n/useTranslate'
import useAuthenStore from '../stores/authen/authenStore'
import Result from '../component/um/settingREC/Result'
import { useSettingREC, Order, SettingRECListType } from '../services/um/useSettingREC'

const SettingREC = () => {
    const authenStore = useAuthenStore()
    const [order, setOrder] = useState<Order>('desc')
    const { getSettingREC } = useSettingREC()
    const [dataList, setDataList] = useState<SettingRECListType[]>([])
    const translate = useTranslate()

    useEffect(() => {
        if (authenStore.profile.userId) {
            handleGetSettingREC(authenStore.profile.userId)
        }
    }, [authenStore.profile.userId])

    const handleGetSettingREC = async (userID: number) => {
        const result = await getSettingREC({ userID })
        setDataList(result)
    }

    const onSort = (order: Order) => {
        const newDataList = orderBy(dataList, ['name.th', 'name.en'], [order])
        setOrder(order)
        setDataList(newDataList)
    }

    return (
        <Container maxWidth="lg">
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginLeft: '0px' }}>
                        {translate.get('LABEL.SETTINGREC')}
                    </Typography>
                    <Result onSort={onSort} order={order} dataList={dataList} />
                </Grid>
            </Grid>
        </Container>
    )
}

export default SettingREC
